// extracted by mini-css-extract-plugin
export default {"mainContainer":"Footer_mainContainer__6KZ1J","linkContainer":"Footer_linkContainer__dKxBN"};